<template>
  <div id="dashboard-page" style="margin-bottom:55px;">
    <b-card>
      <b-row class="mb-0">
        <b-col md="8">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/quotation">Quotation</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="4 text-right mt-4">
          <!-- <b-button v-b-tooltip.hover.top title="Reject" v-if="model.status === 'Issued'" variant="danger" class="btn-md mr-1 mt-0" @click="showModal('reject')">
                    <font-awesome-icon icon="times-circle"></font-awesome-icon>
                </b-button>
                <b-button v-b-tooltip.hover.top title="Approve" v-if="model.status === 'Issued'" variant="success" class="btn-md mr-1 mt-0" @click="showModal('approve')">
                    <font-awesome-icon icon="check-circle"></font-awesome-icon>
                </b-button> -->
          <b-button
            v-b-tooltip.hover.top
            title="Download to PDF"
            @click="doPrint()"
            variant="info"
            class="btn-download float-right"
            ><font-awesome-icon icon="download"
          /></b-button>
        </b-col>
      </b-row>
      <div class="border-bottom"></div>
        <div v-if="isLoading" style="z-index: 1000;">
          <div class="text-center text-primary my-2 h-100">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Loading...</strong>
          </div>
        </div>
        <div v-else>
           <b-form class="mt-3 mx-2">
        <!-- <b-row class="my-3">
                  <div class="icon-flag">
                  </div>
                  <b-col md="6 mt-2">
                    <b-button disabled pill variant="outline-primary" style="font-weight:bold!important;font-size:13px!important;margin-left:-15px!important;" :href="'#'">Company: {{model.company}}</b-button>
                    <b-button class="ml-2" disabled pill variant="outline-primary" style="font-weight:bold!important;font-size:13px!important;" :href="'#'">Branch: {{model.branch}}</b-button>
                  </b-col>
                </b-row> -->
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col md="4"><label class="labels">No. Quotation</label></b-col>
              <b-col md="8"
                ><p>{{ model.quotationId !== '' ? model.quotationId : '-' }}</p></b-col
              >
              <b-col md="4"><label class="labels">Quotation To</label></b-col>
              <b-col md="8"
                ><p>{{ model.customer.name !== '' ? model.customer.name : '-' }}</p></b-col
              >
              <b-col md="4"><label class="labels">Sales Type</label></b-col>
              <b-col md="8"
                ><p>
                  {{ model.customer.salesType !== '' ? model.customer.salesType : '-' }}
                </p></b-col
              >
              <b-col md="4"><label class="labels">Subject</label></b-col>
              <b-col md="8"
                ><p>{{ model.referenceTitle !== '' ? model.referenceTitle : '-' }}</p></b-col
              >
              <b-col md="4"><label class="labels">Valid From</label></b-col>
              <b-col md="8"
                ><p>{{ model.quotationDate !== '' ? getDate(model.quotationDate) : '-' }}</p></b-col
              >
              <b-col md="4"><label class="labels">PIC</label></b-col>
              <b-col md="8"
                ><p>{{ model.quotationPIC !== '' ? model.quotationPIC : '-' }}</p></b-col
              >
              <b-col md="4"><label class="labels">Note</label></b-col>
              <b-col md="8"
                >
                <p style="white-space: pre-wrap; padding:6px; border: 1px solid #f3f3fd;">{{ model.note !==null ? model.note : '-'}}</p>
                </b-col
              >
              <!-- <b-col md="4"><label class="labels">Status</label></b-col> -->
              <!-- <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{model.status}}</b-badge></p></b-col> -->
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row v-if="model.statusValue !== ''">
              <b-col md="4"
                ><label class="labels">{{ model.statusText }}</label></b-col
              >
              <b-col md="8">
                <p>{{ model.statusValue }}</p>
              </b-col>
            </b-row>
            <b-row v-if="model.statusTime !== ''">
              <b-col md="4">
                <label class="labels">{{ model.statusTextTime }}</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.statusTime }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12 mt-3">
            <table class="table table-hovered table-striped">
              <thead>
                <tr>
                  <th width="55">No</th>
                  <th width="400">Item name</th>
                  <th class="text-center" width="160">Quantity</th>
                  <th width="190px" v-if="salesType === 'Personal'">PRICE</th>
                  <th width="190px" v-else-if="salesType === 'Corporate'">PRICE</th>
                  <th width="190px" v-else>PRICE</th>
                  <!-- <th width="200">Unit Price</th> -->
                  <th class="text-center" width="200">Discount (%)</th>
                  <th class="text-center" width="200">Unit</th>
                  <th width="200">Amount</th>
                  <th width="200" class="text-center">Disc Total</th>
                  <th width="200" class="text-center">TAX</th>
                  <th width="200" class="text-center text-bold text-uppercase">Total</th>
                </tr>
              </thead>
              <template>
                <tbody v-if="quotationList.length > 0">
                  <tr v-for="(quotation, index) in quotationList" :key="quotation.uuid">
                    <td>{{ index + 1 }}</td>

                    <td style="white-space: pre-line">
                      <p v-if="quotation.customItem !== null && quotation.customItem !== '' && quotation.customItem !== '-'">
                        {{quotation.customItem }}
                      </p>
                      <p v-else>{{quotation.itemList !== null ? quotation.itemList.name : ''}}</p>

                    </td>

                    <td class="text-center">{{ quotation.quantity }}</td>

                    <td v-if="quotation.customPrice > 0">
                          <p class="mt-3">
                            {{ dataAccount.account.currency }}
                            {{
                              quotation.customPrice !== null ? formatPrice(quotation.customPrice) : '-'
                            }}
                          </p>
                        </td>

                        <td v-else-if="salesType === 'Personal'">
                          <p class="mt-3">
                            {{ dataAccount.account.currency }}
                            {{
                              quotation.itemList.normal_price !== null
                                ? formatPrice(quotation.itemList.normal_price)
                                : '-'
                            }}
                          </p>
                        </td>
                        <td v-else>
                          <p class="mt-3">
                            {{ dataAccount.account.currency }}
                            {{
                              quotation.itemList.corporate_price !== null
                                ? formatPrice(quotation.itemList.corporate_price)
                                : '-'
                            }}
                          </p>
                        </td>

                    <!-- <td v-if="salesType === 'Personal'">
                      {{ dataAccount.account.currency }}
                      {{ formatPrice(quotation.itemList.normal_price) }}
                    </td>

                    <td v-if="salesType === 'Corporate'">
                      {{ dataAccount.account.currency }}
                      {{ formatPrice(quotation.itemList.corporate_price) }}
                    </td> -->

                    <td class="text-center">{{ quotation.discount }}</td>
                    <td class="text-center">{{ quotation.customUnit !== null ? quotation.customUnit : quotation.itemList.unit }}</td>
                    <td class="text-center"> 
                        {{ dataAccount.account.currency }}
                        {{ formatPrice(quotation.subTotal) }}</td>

                    <!-- <td v-if="salesType === 'Personal'">
                      {{ dataAccount.account.currency }}
                      {{
                        formatPrice(
                          quotation.quantity *
                            (quotation.customItem !== null && quotation.customItem !== 0
                              ? quotation.itemList.normal_price
                              : quotation.itemList.normal_price),
                        )
                      }}
                    </td>

                    <td v-if="salesType === 'Corporate'">
                      {{ dataAccount.account.currency }}
                      {{
                        formatPrice(
                          quotation.quantity *
                            (quotation.customItem !== null && quotation.customItem !== 0
                              ? quotation.itemList.corporate_price
                              : quotation.itemList.corporate_price),
                        )
                      }}
                    </td> -->

                    <td class="text-center">
                      {{ dataAccount.account.currency }} {{ formatPrice(quotation.totalDiscount) }}
                    </td>

                    <!-- <td class="text-center">{{ dataAccount.account.currency }} {{formatPrice((quotation.itemList.subTotal * quotation.taxValue) / 100)}}</td> -->
                    <td class="text-center">{{ model.taxValue.name }}</td>

                    <td class="text-center">
                      {{ dataAccount.account.currency }}
                      {{ formatPrice(quotation.totalPriceAfterDiscount) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </table>
            <p style="opacity: 0.6;" class="text-danger text-right font-weight-light">
              <i>*total price does not include tax fees</i>
            </p>
          </b-col>
        </b-row>
        <b-row>
          <!-- <b-col md="7 mt-1">
                  <p id="value" class="float-right value-row"><b></b></p>
                </b-col>
                <b-col md="2 mt-1">
                  <p id="value" class="value-row"><b>Sub Total:</b></p>
                  <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                </b-col>
                <b-col md="2">
                  <p id="value" class="float-right tax-value"><b>{{this.currency === 'Rp' ? 'Rp' : 'RM'}} {{formatPrice()}}</b></p>
                </b-col> -->
        </b-row>
        <!-- <b-row>
                <b-col md="7 mt-1">
                  <p id="value" class="float-right value-row"><b></b></p>
                </b-col>
                <b-col md="2 mt-1">
                  <p id="value" class="value-row"><b>Disc Total:</b></p>
                  <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                </b-col>
                <b-col md="2">
                  <p id="value" class="float-right tax-value"><b>{{this.currency === 'Rp' ? 'Rp' : 'RM'}} {{formatPrice}}</b></p>
                </b-col>
              </b-row> -->
        <b-row>
          <!-- <b-col md="7 mt-1">
                  <p id="value" class="float-right value-row"><b></b></p>
                </b-col>
                <b-col md="2 mt-1">
                  <p id="value" class="value-row"><b>Total:</b></p>
                  <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                </b-col>
                <b-col md="2">
                  <p id="value" class="float-right tax-value"><b>{{this.currency === 'Rp' ? 'Rp' : 'RM'}} {{formatPrice(quotationList.quantity * (quotationList.customItem !== null && quotationList.customItem !== 0 ? quotationList.customItem : quotationList.itemList.corporate_price ))}}</b></p>
                </b-col>
              </b-row> -->
          <b-row>
            <!-- <b-col md="7"> </b-col>
                <b-col md="1 mt-3">
                  <p class="tax-values"><b>Tax:</b></p>
                </b-col>
                <b-col md="2">
                </b-col>
                <b-col md="1" class="align-items-center">
                 <span class="align-items-center">
                   <h5 id="value" class="value-row text-bold p-0">{{model.taxValue.name}}</h5>
                 </span>
                </b-col> -->
            <!-- <b-col md="7 mt-1"> </b-col>
                <b-col md="4">
                  <p id="value" class="value-row"><b></b></p>
                  <hr width="100%" style="margin-bottom: 0px!important;" />
                </b-col> -->
          </b-row>
          <!-- <b-row>
                <b-col md="7 mt-1">
                  <p id="value" class="float-right value-row"><b></b></p>
                </b-col>
                <b-col md="2 mt-1">
                  <p id="value" class="value-row"><b>Total Tax:</b></p>
                  <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                </b-col>
                
              </b-row> -->
          <!-- <b-row>
                <b-col md="7 mt-1">
                  <p id="value" class="float-right value-row"><b></b></p>
                </b-col>
                <b-col md="2 mt-1">
                  <p id="value" class="value-row" style="font-size:18px!important;">
                    <b class="text-primary text-bold">Grant Total:</b>
                  </p>
                  <hr class="hr-tax" width="227%" style="margin-bottom: 0px!important;" />
                </b-col>
                <b-col md="2">
                  <span id="value" class="float-right tax-value" style="font-size:18px!important;">
                    <h5 class="text-bold">{{this.currency === 'Rp' ? 'Rp' : 'RM'}} {{formatPrice(totalPriceAfterDiscount)}}</h5>
                  </span>
                </b-col>
              </b-row> -->
          <!-- </b-col> -->
        </b-row>
        <b-card class="mt-5 mb-4 bordered-card" bg-variant="light">
          <b-row>
            <!-- <b-col md="3">
                  </b-col> -->
            <b-col md="5">
              <b-card class="border-none">
                <label class="labels">Term and Conditions</label>
                <wysiwyg id="termCondition" v-model="model.termCondition" placeholder="" />
                <!-- <b-form-textarea readonly rows="15" style="font-size:12px!important; background-color:#fff!important; text-align:justify; border:none!important;" v-model="model.termConditions">
                      </b-form-textarea> -->
              </b-card>
            </b-col>
            <b-col md="2"> </b-col>
            <b-col md="5" class="mt-5">
              <label for="" class="labels">Signed By</label>
              <br />
              <br />
              <br />
              <p class="text-bold">
                {{ model.signedBy.firstName + ' ' + model.signedBy.lastName }}
              </p>
            </b-col>
            <!--<b-col md="5 mt-5">
                    <b-card bg-variant="none" class="border-none mt-1">
                      <label class="labels mt-3">Issued By</label><br>
                      <p class="underline labels text-center" style="width:100%!important;margin-top:10px!important; margin-bottom:25px!important; box-shadow:none!important;"></p>
                      <label class="labels mt-5">Position</label><br>
                      <p class="underline labels text-center" style="width:100%!important; margin-top:10px!important; margin-bottom:25px!important"></p>
                    </b-card>
                  </b-col>-->
          </b-row>
        </b-card>
        <b-row>
          <b-col> </b-col>
        </b-row>
        <b-modal id="bv-modal-example" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">{{ type }} Quotation</h5>
          </template>
          <form v-on:submit.prevent="doChangeStatus(type)">
            <div class="d-block">
              <!--<label for=""><strong>Type</strong></label>
                      <b-form-input v-model="formData.type" disabled placeholder="Enter type"></b-form-input>-->
              <label for="" class="labels mt-2">Note</label>
              <b-form-textarea
                rows="3"
                v-model="formData.note"
                placeholder="Enter Note"
              ></b-form-textarea>
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
            >
            <b-button variant="primary" type="submit" class="mt-4 float-right">
              <font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button
            >
          </form>
        </b-modal>
        <b-modal id="bv-modal-print" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">Quotation Issued</h5>
          </template>
          <form v-on:submit.prevent="doPrint()">
            <div class="d-block">
              <label for="" class="labels">Issued By *</label>
              <b-form-input
                v-model="formData.issuedBy"
                required
                placeholder="Enter Issued By"
              ></b-form-input>
              <label for="" class="mt-4 labels">Position *</label>
              <b-form-input
                v-model="formData.position"
                required
                placeholder="Enter Position"
              ></b-form-input>
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-print')"
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
            >
            <b-button variant="primary" type="submit" class="mt-4 float-right">
              <font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button
            >
          </form>
        </b-modal>
      </b-form>
        </div>
     
      <b-button class="mt-3" :to="'/sales/quotation'" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
      <b-button
        class="mt-3 float-right"
        :to="'/sales/quotation/' + $route.params.uuid + '/edit'"
        variant="warning"
        ><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button
      >
    </b-card>
  </div>
</template>

<script>
import wysiwyg from 'vue-wysiwyg';
import Vue from 'vue';
Vue.use(wysiwyg, {
  hideModules: {
    headings: true,
    code: true,
    link: true,
    image: true,
    table: true,
    unorderedList: true,
    separator: true,
  },
}); // config is optional. more below
export default {
  name: 'quotation-details',
  data() {
    return {
      isLoading: false,
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        quotation: window.AppConfig.apiUrl + 'quotation',
        exportQuotationDetail: window.AppConfig.apiUrl + 'export-quotation-detail',
        // quotationHistory: window.AppConfig.apiUrl + 'quotation-history-status'
      },
      salesType: '',
      model: {
        company: '',
        branch: '',
        quotationId: '',
        referenceTitle: '',
        quotationDate: '',
        quotationPIC: '',
        customer: '',
        orderType: '',
        customItem: '',
        customPrice: '',
        termCondition: '',
        createdAt: '',
        status: '',
        subtotal: 0,
        dueDate: '',
        note: '',
        taxValue: {
          name: '',
          value: '',
          valued: '',
        },
        total: 0,
        statusText: '',
        statusValue: '',
        statusTime: '',
        statusTextTime: '',
        signedBy: '',
      },
      customerValue: '',
      taxes: '',
      currency: '',
      formData: {
        note: null,
        issuedBy: '',
        position: '',
        // type: 'sales-order'
      },
      quotationList: [],
      quotationHistoryList: [],
    };
  },
  watch: {
    // 'model.customer'(value) {
    //   this.getCustomerByValue(value)
    // },
    // 'model.taxValue'(value) {
    //   this.getTaxByValue(value)
    // },
    // 'tableFilter.name' () {
    //   this.doFilter()
    // },
  },
  mounted() {
    this.getDetail();
    // this.getHistoryStatus()
    // this.getCustomerByValue();
    // this.getCustomer()
  },
  methods: {
    getDetail() {
      this.isLoading = true;
      this.$http.get(this.apiUrl.quotation + '/' + this.$route.params.uuid).then((response) => {
        this.salesType = response.data.customer.salesType;
        console.log(this.salesType);
        this.model.quotationId =
          response.data.quotationId !== null && response.data.quotationId !== 'null'
            ? response.data.quotationId
            : '-';
        // this.model.orderType = response.data.orderType !== null && response.data.orderType !== 'null' ? response.data.orderType : '-'
        this.model.customer =
          response.data.customer !== null && response.data.customer !== 'null'
            ? response.data.customer
            : '-';
        this.model.referenceTitle =
          response.data.referenceTitle !== null ? response.data.referenceTitle : '-';
        this.model.quotationPIC =
          response.data.quotationPIC !== null ? response.data.quotationPIC : '-';
        // this.model.company = response.data.company !== null ? response.data.company.name : '-'
        this.model.taxValue.name =
          response.data.taxValue !== null &&
          response.data.taxValue !== '' &&
          response.data.taxValue !== 'null' &&
          response.data.taxValue !== undefined
            ? response.data.taxValue.name
            : '-';
        this.model.taxValue.value =
          response.data.taxValue !== null &&
          response.data.taxValue !== '' &&
          response.data.taxValue !== 'null' &&
          response.data.taxValue !== undefined
            ? this.model.taxValue.value
            : '0.00';
        this.model.dueDate = response.data.dueDate;
        this.model.quotationDate = response.data.quotationDate;
        this.model.signedBy = response.data.signedBy;
        this.model.termCondition =
          response.data.termCondition !== null && response.data.termCondition !== 'null'
            ? response.data.termCondition
            : '';
        this.model.note =
          response.data.note !== null && response.data.note !== 'null' ? response.data.note : '';
        this.currency = response.data.account.currency;
        this.quotationList = [];
        this.model.subtotal = 0;
        if (response.data.quotationItem !== null) {
          this.taxes = response.data.taxValue !== null ? response.data.taxValue.value : '0.00';
          response.data.quotationItem.forEach((data) => {
            this.quotationList.push(data);
            console.log('ini datanya', this.quotationList);
            this.model.subtotal += Math.round(data.balance);
            this.model.taxValue.valued = (this.model.subtotal * this.taxes) / 100;
            this.model.total = this.model.subtotal + this.model.taxValue.valued;
          });
        }
        // if (response.data.rejectedBy !== null) {
        //   this.model.statusText = 'Rejected By'
        //   this.model.statusTextTime = 'Rejected Time'
        //   this.model.statusValue = response.data.rejectedBy
        //   this.model.statusTime = response.data.rejectedTime !== null ? this.$moment(response.data.rejectedTime).format('YYYY-MM-DD hh:mm A') : '-'
        // }
        // if (response.data.approvedBy !== null) {
        //   this.model.statusText = 'Approved By'
        //   this.model.statusTextTime = 'Approved Time'
        //   this.model.statusValue = response.data.approvedBy
        //   this.model.statusTime = response.data.approvedTime !== null ? this.$moment(response.data.approvedTime).format('YYYY-MM-DD hh:mm A') : '-'
        // }
        this.isLoading = false;
      });
    },
    // getCustomer () {
    //   this.isLoading = true
    //   this.$http.get(window.AppConfig.apiUrl + 'customer').then(response => {
    //     this.currency = response.data.account.currency
    //   })
    // },

    // getHistoryStatus () {
    //   this.isLoading = true
    //   this.$http.get(this.apiUrl.quotationHistory + '?quotation_uuid=' + this.$route.params.uuid + '&ascending=1').then(response => {
    //     this.quotationHistoryList = []
    //     response.data._embedded.quotation_history_status.forEach(data => {
    //       this.quotationHistoryList.push(data)
    //     })
    //     this.isLoading = false
    //   })
    // },
    doExportToPDF() {
      let url =
        this.apiUrl.exportQuotationDetail +
        '?token=' +
        this.$store.getters['account/tokens'].access_token +
        '&quotation_uuid=' +
        this.$route.params.uuid;
      //  '&validator_person=' + '&validator_position='
      window.open(url);
    },
    showModal(type) {
      this.formData.note = null;
      // this.formData.type = this.formData.type
      this.type = type;
      this.$bvModal.show('bv-modal-example');
    },

    getCustomer() {
      this.$http
        .get(window.AppConfig.apiUrl + 'customer?limit=100')
        .then((response) => {
          this.customerList = [];
          response.data._embedded.customer.forEach((data) => {
            this.customerSales = data.salesType;
            this.customerList.push({
              value: data.uuid,
              text: data.name,
            }),
              (this.currency = data.account.currency);
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    // getCustomerByValue(uuid) {
    //   this.customerValue = '';
    //   this.$http.get(window.AppConfig.apiUrl + 'customer' + '/' + uuid).then(response => {
    //     this.customerValue = response.data.salesType;
    //     if( this.customerValue === 'Personal') {
    //       this.getTotalPersonalOrder()
    //       this.getDiscTotalPersonal()
    //       this.getSubtotalPersonal()
    //       this.getTotalPersonal()
    //     } else {
    //       this.getTotalCorporateOrder()
    //       this.getDiscTotalCorporate()
    //       this.getSubtotalCorporate()
    //       this.getTotalCorporate()
    //     }
    //     console.log("value ny adalah", this.customerValue);
    //   }).catch(error => {
    //     window.consoleLog(error)
    //   })
    // },
    // doChangeStatus (type) {
    //   this.isLoading = true
    //   this.$http.post(window.AppConfig.apiUrl + 'quotation-action', {
    //     uuid: this.$route.params.uuid,
    //     action: type,
    //     // type: this.formData.type,
    //     note: this.formData.note
    //   })
    //   .then(() => {
    //     this.isLoading = false
    //     this.formData.note = null
    //     this.getDetail()
    //     this.getHistoryStatus()
    //     this.$bvModal.hide('bv-modal-example')
    //     if (type === 'reject') {
    //       this.$store.dispatch('notification/success', 'Quotation has been ' + type + 'ed')
    //     } else {
    //       this.$store.dispatch('notification/success', 'Quotation has been ' + type + 'd')
    //     }
    //   })
    //   .catch(error => {
    //     this.isLoading = false
    //     this.$store.dispatch('notification/error', error)
    //   });
    // },
    // showModalPrint () {
    //   this.formData.issuedBy = null
    //   this.formData.position = null
    //   this.$bvModal.show('bv-modal-print')
    // },
    doPrint() {
      this.isLoading = true;
      let url =
        this.apiUrl.exportQuotationDetail +
        '?token=' +
        this.$store.getters['account/tokens'].access_token +
        '&quotation_uuid=' +
        this.$route.params.uuid +
        '&validator_person=' +
        this.formData.issuedBy +
        '&validator_position=' +
        this.formData.position;

      // this.$bvModal.hide('bv-modal-print')

      window.open(url);
      this.isLoading = false;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm A');
      } else {
        return '-';
      }
    },
    getDate(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD');
      } else {
        return '-';
      }
    },
    goBack() {
      window.goBack(this);
    },
    getStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;
        case 'New':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Approved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Completed':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Rejected':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Paid':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Finished':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Issued':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
        case false:
          return 'secondary';
          // eslint-disable-next-line no-unreachable
          break;
        case true:
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case '0':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case '1':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>
<style>
.edited-text {
  background-color: #3d464d !important;
  color: #fff !important;
  padding-top: 5px !important;
}
.labeled {
  font-size: 13px !important;
  margin-left: 5px !important;
}
</style>
<style scoped>
@import '~vue-wysiwyg/dist/vueWysiwyg.css';
</style>
